export class Permission {
  id: number;
  group: string; // resource_uri группы
  user: string; // resource_uri пользователя
  members?: number; // количество участников в группе
  name: string; // название группы или имя пользователя
  type: PermissionType;
  project: string; // resource_uri проекта
  resource_uri: string;
  layerPermissions: LayerPermission[] = [];

  constructor(options?: any) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class LayerPermission {
  id: number;
  resource_uri: string;
  type: PermissionType;
  layer: string; // resource_uri слоя
  layer_id: number;
  layer_name: string;
  project_permission: string; // resource_uri права

  constructor(options?: any) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export interface PermissionSubject {
  id: number;
  resource_uri: string;
  name: string;
  // количество участников в группе
  members?: number;
  type: PermissionSubjectType;
}

export type PermissionSubjectType = 'group' | 'user';

export interface PermissionTypeItem {
  type: PermissionType;
  name: string;
  description: string;
}

export const PermissionTypes: PermissionTypeItem[] = [
  {
    type: 'P',
    name: 'Частичный доступ',
    description: 'Пользователи видят проект в списке, могут просматривать и редактировать только слои, указанные в настройках'
  },
  {
    type: 'V',
    name: 'Может просматривать',
    description: 'Пользователи видят проект в списке и могут просматривать все слои'
  },
  {
    type: 'E',
    name: 'Может изменять',
    description: 'Пользователи могут редактировать проект, список слоев и краудсорсинг, а также управлять всеми слоями'
  },
  {
    type: 'F',
    name: 'Полный доступ',
    description:
      'Пользователи могут редактировать и удалять проект, настраивать список слоев, краудсорсинг и права доступа, а также управлять всеми слоями'
  }
];

export type PermissionType = 'P' | 'V' | 'E' | 'F';
